module.exports = __webpack_public_path__ + "8dca54ab591e95adc6d1511aaa41b8e8.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/wasistgoldencity5.jpg
// module id = 505
// module chunks = 0